var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxAnswers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8927 36.1894C32.8927 36.1894 27.1202 31.9997 26.9522 31.8328C18.9087 26.6374 19.4116 20.7723 19.4116 20.7723V6.02598L32.8927 0.999695",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8927 36.1894C32.8927 36.1894 38.6653 31.9997 38.8333 31.8328C46.8767 26.6374 46.3738 20.7723 46.3738 20.7723V6.02598L32.8927 0.999695",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.981 31.1038L27.4793 26.697C27.4793 26.697 23.9639 24.2272 23.5056 20.1004C23.6587 19.9484 23.5056 9.09696 23.5056 9.09696L32.8964 5.58267",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8965 31.1038L38.3983 26.697C38.3983 26.697 41.9137 24.2272 42.372 20.1004C42.2188 19.9484 42.372 9.09696 42.372 9.09696L32.9811 5.58267",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6499 54.9579H5.52421C3.02592 54.9579 0.999634 52.9327 0.999634 50.4333H64.1745C64.1745 52.9327 62.1482 54.9579 59.6499 54.9579Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3166 16.0807H57.1669C58.3989 16.0807 59.3989 17.0807 59.3989 18.3127V50.4328H5.776V18.3127C5.776 17.0807 6.77486 16.0807 8.008 16.0807H19.3429",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3332 53.6455H29.8406C28.5069 53.6455 27.4269 52.5644 27.4269 51.2318V50.697H37.7469V51.2318C37.7469 52.5644 36.6669 53.6455 35.3332 53.6455Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6122 20.3063H54.0111V45.5566H10.7242V20.3063H18.4911",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3385 16.4031L30.6288 20.0671L38.0871 13.8522",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxAnswers);
export default __webpack_public_path__ + "static/media/tax_answers.4afadea7c17cd5f689645c3efbdc5e9d.svg";
export { ForwardRef as ReactComponent };